/**
 * A from/to pair. The value is committed on blur or Enter, not on every keystroke,
 * so typing "450000" does not fire five requests.
 */
import { useEffect, useState } from 'react';

type BereikProps = {
  min: number | undefined;
  max: number | undefined;
  eenheid?: string;
  stap?: number;
  /**
   * Wat er binnen het huidige filter werkelijk in de data zit. Staat als
   * voorbeeldwaarde in het lege veld: een invoer van 80-120 m² gaf '0 woningen'
   * terwijl de hele set tussen 50 en 70 ligt, en niets verried dat het filter
   * werkte en de data gewoon op was.
   */
  hint?: { min: number | null; max: number | null };
  onWijzig: (waarden: { min: number | undefined; max: number | undefined }) => void;
};

export function Bereik({ min, max, eenheid, stap = 1, hint, onWijzig }: BereikProps) {
  const [van, zetVan] = useState(tekst(min));
  const [tot, zetTot] = useState(tekst(max));

  useEffect(() => {
    zetVan(tekst(min));
    zetTot(tekst(max));
  }, [min, max]);

  function leg(nieuweVan: string, nieuweTot: string) {
    onWijzig({ min: getal(nieuweVan), max: getal(nieuweTot) });
  }

  return (
    <div className="flex items-center gap-1.5">
      <input
        className="veld cijfers"
        inputMode="numeric"
        step={stap}
        aria-label="van"
        placeholder={hint?.min == null ? 'van' : String(hint.min)}
        value={van}
        onChange={(event) => zetVan(event.target.value)}
        onBlur={() => leg(van, tot)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') leg(van, tot);
        }}
      />
      <span className="text-faint">–</span>
      <input
        className="veld cijfers"
        inputMode="numeric"
        step={stap}
        aria-label="tot"
        placeholder={hint?.max == null ? 'tot' : String(hint.max)}
        value={tot}
        onChange={(event) => zetTot(event.target.value)}
        onBlur={() => leg(van, tot)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') leg(van, tot);
        }}
      />
      {eenheid ? <span className="text-[11.5px] text-muted">{eenheid}</span> : null}
    </div>
  );
}

function tekst(waarde: number | undefined): string {
  return waarde === undefined ? '' : String(waarde);
}

function getal(waarde: string): number | undefined {
  const schoon = waarde.replace(/[^\d]/g, '');
  if (schoon === '') return undefined;
  const nummer = Number(schoon);
  return Number.isFinite(nummer) ? nummer : undefined;
}
